<template>

    <div>
        <v-select multiple :label="label" :item-value="itemValue" v-model="selectedItem"  :options="options">
            <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope"><slot :name="slot" v-bind="scope"/></template>
            <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot"/>
        </v-select>
        <div v-if="selectedItemsInput">
             <input type="hidden" v-for="(item, key) in selectedItemsInput" :key="key" :name="name" :value="selectedItemsInput[key]">
        </div>
    </div>

</template>

<script>

export default{

    props: {
        options: {
            type : Array,
            default : []
        },
        label: '',
        itemValue: '',
        selected: {
            type : Array,
            default : []
        },
        name: '',
    },

    data() {

        return {
            items: this.options,
            selectedItem: this.selected,
        };
    },

    computed: {
        selectedItemsInput: function() {

            if (this.selectedItem) {

                let tempSelected = [];

                this.selectedItem.forEach(item => {
                    tempSelected.push(item[this.itemValue]);
                });

                return tempSelected;
            }
            else {
                return '';
            }
        },
    }

};

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/common/HtmlVueSelectMultiple.vue